import React, { useEffect } from 'react';
import useToolStore, { TOOL_TYPES } from '../../../store/useToolStore';
import { generateCode } from '../../../utils/codeGenerators';
import ApiGeneratorPreview from './ApiGeneratorPreview';
import ApiGeneratorControls from './ApiGeneratorControls';

const ApiGenerator = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.API_GENERATOR]);
  const updateConfig = useToolStore((state) => state.updateToolConfig);
  const setGeneratedCode = useToolStore((state) => state.setGeneratedCode);

  useEffect(() => {
    const code = generateCode(TOOL_TYPES.API_GENERATOR, config);
    setGeneratedCode(code);
  }, [config, setGeneratedCode]);

  const handleConfigChange = (newConfig) => {
    updateConfig(TOOL_TYPES.API_GENERATOR, newConfig);
  };

  return (
    <div className="p-6">
      <h2 className="text-xl font-bold mb-4 text-gray-900 dark:text-white">API Generator</h2>
      <ApiGeneratorControls config={config} onChange={handleConfigChange} />
    </div>
  );
};

export const ApiGeneratorPreviewComponent = () => {
  const config = useToolStore((state) => state.toolConfigs[TOOL_TYPES.API_GENERATOR]);
  return <ApiGeneratorPreview config={config} />;
};

export default ApiGenerator;

